module.exports = __webpack_public_path__ + "img/thumb_23.fe194a3c.jpg";